
    $(document).ready(function () {
      function openCartDrawer() {
        $('#CartDrawer').addClass('active');
        $('body').addClass('cart-drawer-open');
      }

      function closeCartDrawer() {
        $('#CartDrawer').removeClass('active');
        $('body').removeClass('cart-drawer-open');
      }

      // Bag / cart icon

   document.addEventListener('click', function (e) {

  const cart = e.target.closest('.header-tools-cart');

  if (!cart) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  openCartDrawer();
  $('#CartDrawer').addClass('active');

}, true);

      // Close button
      $(document).on('click', '#CartDrawer .cart-drawer__close', function (e) {
          e.preventDefault();
    
        closeCartDrawer();
        $('#CartDrawer').removeClass('active');
        $('body').removeClass('cart-drawer-open');
      });

      // Overlay
      $(document).on('click', '#CartDrawer .cart-drawer__overlay', function () {
        closeCartDrawer();
      });


    $(document).on('click', '.cart-summary-heading', function (e) {
  e.preventDefault();

  const $summary = $(this).closest('.cart-drawer__summary');
   let $dropSVG = $(this).find('.estimation_dropdown svg');
  $dropSVG.toggleClass('rotation');

  $summary
    .find('.summery__dropDown')
    .toggleClass('active');
});

   function updateCartDrawer() {

    $.ajax({
      url: '/?section_id=cart-drawer2',
      type: 'GET',

      success: function (response) {

        let $newDrawer = $(response).find('#CartDrawer');

        $('#CartDrawer').html(
          $newDrawer.html()
        );

        initCartUpsellSlider();
      },

      error: function (error) {
        console.log('Drawer refresh error:', error);
        initCartUpsellSlider();
      }
    });

  }

  $(document).on('click', '.cart-quantity-btn', function () {

    let $button = $(this);
    let key = $button.data('key');
    let change = Number($button.data('change'));

    // Get current quantity
    let $quantity = $button
      .closest('.cart-drawer__quantity')
      .find('.cart-quantity');

    let currentQuantity = Number($quantity.text());

    let newQuantity = currentQuantity + change;

    // Don't allow quantity below 0
    if (newQuantity < 0) {
      newQuantity = 0;
    }

    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        id: key,
        quantity: newQuantity
      }),

      success: function (cart) {

        console.log('Cart updated:', cart);

        // Refresh drawer
        updateCartDrawer();

      },

      error: function (error) {
        console.log('Cart update error:', error);
      }
    });

  });

  $(document).on('click', '.cart-drawer__remove', function () {

    let key = $(this).data('key');

    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      contentType: 'application/json',

      data: JSON.stringify({
        id: key,
        quantity: 0
      }),

      success: function (cart) {

        console.log('Item removed:', cart);

        updateCartDrawer();
        

      },

      error: function (error) {
        console.log('Remove error:', error);
      }
    });

  });







  






  
    });
